export const SitePermissions = {
  ['access__settings']: 0n,
  ['access__retail']: 1n,
  ['access__clients']: 2n,
  ['access__dashboards__display_home_revenue_and_retail_snapshot']: 3n,
  ['access__dashboards__display_home_snapshot']: 4n,
  ['access__notifications__receive_sms_running_low']: 5n,
  ['access__notifications__receive_account_delete_and_refund_failed_email']: 6n,
  ['access__reports']: 7n,
  ['schedule__team_view_access']: 8n,
  ['schedule__booking_for_all_team_members']: 9n,
  ['schedule__booking_requests']: 10n,
  ['schedule__allow_as_instructor_for_schedule']: 11n,
  ['schedule__sessions__add_and_edit']: 12n,
  ['schedule__sessions__cancel']: 13n,
  ['schedule__allow_custom_session_creation']: 14n,
  ['schedule__edit_of_employee_work_hours']: 15n,
  ['schedule__add_or_remove_booked_clients']: 16n,
  ['schedule__communicate_with_clients_within_schedule']: 17n,
  ['schedule__enable_late_cancel_and_refund']: 18n,
  ['schedule__class_rating']: 19n,
  ['schedule__soap_notes__read']: 20n,
  ['schedule__soap_notes__write']: 21n,
  ['schedule__allow_bookings_for_team_outside_of_employee_work_hours']: 22n,
  ['schedule__enable_sub_instructor']: 23n,
  ['schedule__enable_sub_instructor_edit_instructor']: 24n,
  ['payments__request_payment_access']: 25n,
  ['payments__process_payments_within_schedule']: 26n,
  ['payments__payroll_report_access']: 27n,
  ['payments__access_to_cash_draw']: 28n,
  ['schedule__enable_checkin_popups']: 29n,
  ['schedule__bulk_cancel_sessions']: 30n,
  ['payments__change_client_payment_method']: 31n,
  ['payments__send_payment_request_email']: 32n,
  ['payments__retry_failed_payment_with_payment_method']: 33n,
  ['payments__edit_dishonor_fee']: 34n,
  ['payments__service_cancellation']: 35n,
  ['payments__advanced_checkout']: 36n,
  ['payments__advanced_checkout__credit_activation_date']: 37n,
  ['payments__advanced_checkout__first_payment_date']: 38n,
  ['payments__advanced_checkout__credit_valid_until']: 39n,
  ['payments__advanced_checkout__auto_renew']: 40n,
  ['payments__advanced_checkout__one_time_setup_fee']: 41n,
  ['payments__advanced_checkout__discount_any_price']: 42n,
  ['payments__advanced_checkout__discount_only_lower_price']: 43n,
  ['payments__bulk_edit_transactions']: 44n,
  ['settings__retail']: 45n,
  ['settings__retail__packages__read']: 46n,
  ['settings__retail__packages__write']: 47n,
  ['settings__retail__packages__write_restricted']: 48n,
  ['settings__retail__packages__archive']: 49n,
  ['settings__retail__memberships__read']: 50n,
  ['settings__retail__memberships__write']: 51n,
  ['settings__retail__memberships__write_restricted']: 52n,
  ['settings__retail__memberships__archive']: 53n,
  ['settings__retail__products__read']: 54n,
  ['settings__retail__products__write_add']: 55n,
  ['settings__retail__products__write_edit']: 56n,
  ['settings__retail__promo_codes']: 57n,
  ['settings__retail__gift_cards__read']: 58n,
  ['settings__retail__gift_cards__write']: 59n,
  ['settings__retail__fees']: 60n,
  ['settings__retail__sale_settings']: 61n,
  ['settings__retail__general_settings']: 62n,
  ['settings__retail__terminals']: 63n,
  ['settings__account']: 64n,
  ['settings__account__billing']: 65n,
  ['settings__account__tax']: 66n,
  ['settings__account__invoice']: 67n,
  ['settings__account__point_of_sale']: 68n,
  ['settings__account__payroll']: 69n,
  ['settings__location']: 70n,
  ['settings__location__configurations']: 71n,
  ['settings__location__integrations']: 72n,
  ['settings__location__tools']: 73n,
  ['settings__location__operations']: 74n,
  ['settings__location__checkin']: 75n,
  ['settings__location__communication']: 76n,
  ['settings__location__social_media']: 77n,
  ['settings__scheduler']: 78n,
  ['settings__scheduler__rules']: 79n,
  ['settings__scheduler__session_types']: 80n,
  ['settings__scheduler__session_templates']: 81n,
  ['settings__scheduler__calendar_configurations']: 82n,
  ['clients__client_password_reset']: 83n,
  ['clients__client_merge']: 84n,
  ['clients__programs']: 85n,
  ['clients__leads']: 86n,
  ['clients__feedback']: 87n,
  ['clients__groups']: 88n,
  ['clients__delete']: 89n,
  ['clients__bulk_edit_packages_expiry_date']: 90n,
  ['reports__edit_restricted_reports']: 91n,
  ['reports__client_and_attendance']: 92n,
  ['reports__marketing']: 93n,
  ['reports__financial']: 94n,
  ['reports__staff']: 95n,
  ['reports__inventory']: 96n,
  ['settings__account__sms_credits']: 112n,
  ['reports__download']: 113n,
  ['site_pii__view_contact_details']: 114n,
  ['site_pii__view_full_identity']: 115n,
  ['site_pii__export_pii']: 116n,
  ['content__create']: 117n,
  ['content__edit_own']: 118n,
  ['content__publish_own']: 119n,
  ['content__delete_own']: 120n,
  ['content__view_corporate']: 121n,
  ['wellness__equipments__manage']: 122n,
  ['settings__location__website_widgets']: 123n,
  ['payments__service_plan_change']: 124n,
  ['import__initiate']: 129n,
  ['import__preview']: 130n,
  ['import__approve_and_execute']: 131n,
  ['import__delete']: 132n,
  ['import__download_source']: 133n,
  ['import__download_audit']: 134n,
  // CORE-1322 / INT-67: per-site accounting-code library (gateway-neutral keys; DD-011).
  // Values are unique bit indices in the permission bitmask — appended after the current max (134n);
  // the 97–111n / 125–128n gaps are intentionally NOT reused (retired bits).
  ['settings__retail__account_codes__read']: 135n,
  ['settings__retail__account_codes__write']: 136n,
} as const

export type SitePermissionsKey = keyof typeof SitePermissions
